import { globalResources, errorMessages } from "./global-resource";

const sendHttpRequest = (url, method, data, contentType) => {
    ajaxLoader.show();

    // set up our HTTP request
    const req = new XMLHttpRequest();

    return new Promise((resolve, reject) => {
        req.open(method || "GET", url);

        // set headers
        if (contentType) req.setRequestHeader("Content-Type", contentType);

        // send the request
        if (data) req.send(data);
        else req.send();

        // done!
        req.onload = () => {
            if (req.status === 200) {
                if (req.responseText.length > 0)
                    resolve(JSON.parse(req.responseText));
                else resolve(req);
            } else {
                console.warn(req.status);

                const response = req.responseText?.replaceAll('"', "")
                let message = "در هنگام انجام درخواست شما خطایی رخ داد، لطفا مجددا تلاش نمایید"
                
                const culture = document.documentElement.lang.replace('-', '_')
                const errorMessage = helper.getErrorMessage(response, culture);
                if (response)
                    message = errorMessage ?? response

                notify.show({
                    message,
                    type: "error",
                    autoClose: true,
                });

                resolve(req);

                reject({
                    status: req.status,
                    statusText: req.statusText,
                });
            }
        };

        // only triggers if the request couldn't be made at all
        req.onerror = () => {
            console.error(req.status);

            notify.show({
                message:
                    "در هنگام انجام درخواست شما خطایی رخ داد، لطفا مجددا تلاش نمایید",
                type: "error",
                autoClose: true,
            });

            reject({
                status: req.status,
                statusText: req.statusText,
            });
        };

        req.onreadystatechange = function () {
            // UNSENT: initial state
            if (req.readyState == 0) {
            }
            // OPENED: open called
            else if (req.readyState == 1) {
            }
            // HEADERS_RECEIVED: response headers received
            else if (req.readyState == 2) {
            }
            // LOADING: response is loading (a data packed is received)
            else if (req.readyState == 3) {
            }
            // DONE: request finished
            else if (req.readyState == 4) {
                ajaxLoader.hide();
            }
        };
    });
};

export class http {
    static get(url, param) {
        return sendHttpRequest(
            typeof param === "undefined" ? url : `${url}/${param}`
        );
    }

    static post(url, data) {
        return sendHttpRequest(
            url,
            "POST",
            JSON.stringify(data),
            "application/json"
        );
    }

    static upload(url, data) {
        return sendHttpRequest(url, "POST", data);
    }
}

export class confirm {
    static show(fn, msg = "آیا می خواهید ادامه دهید؟") {
        $.confirm({
            title: "پیام سیستم!",
            content: msg,
            theme: "supervan",
            rtl: true,
            buttons: {
                confirm: {
                    text: "تایید",
                    action: () => fn(),
                },
                cancel: {
                    text: "انصراف",
                },
            },
        });
    }
}

export class notify {
    static show(options) {
        options = options || {
            message: "درخواست شما با موفقیت انجام شد",
        };

        $.wiNotify(options);
    }
}

export class helper {
    static toEnglishNumber(x) {
        let charCodeZero = "۰".charCodeAt(0);
        return parseInt(
            x.replace(/[۰-۹]/g, (w) => w.charCodeAt(0) - charCodeZero)
        ).toString();
    }

    static toEnglishString(x) {
        let charCodeZero = "۰".charCodeAt(0);
        return x.replace(/[۰-۹]/g, (w) => w.charCodeAt(0) - charCodeZero
        ).toString();
    }

    static toFarsiNumber(x) {
        if (typeof x === "undefined") return "";

        if (typeof x !== "string") x = x.toString();

        let numbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        return x.replace(/[0-9]/g, (w) => numbers[+w]);
    }

    static toMoney(x) {
        if (typeof x === "undefined") return "";

        let s = x.toString();
        if (s.length < 1) return x;
        return s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    static log(msg, type) {
        if (typeof type === "undefined") type = "log";

        console[type]("--------------------------------");
        console[type](msg);
        console[type]("--------------------------------");
    }

    static toAlphabeticNumber(i) {
        if (i == 0) return "صفر";
        if (i == 1) return "یک";
        if (i == 2) return "دو";
        if (i == 3) return "سه";
        if (i == 4) return "چهار";
        if (i == 5) return "پنج";
        if (i == 6) return "شش";
        if (i == 7) return "هفت";
        if (i == 8) return "هشت";
        if (i == 9) return "نه";
    }

    static uuid() {
        let a, b;
        // ref: https://gist.github.com/LeverOne/1308368
        for (
            b = a = "";
            a++ < 36;
            b +=
                (a * 51) & 52
                    ? (a ^ 15
                          ? 8 ^ (Math.random() * (a ^ 20 ? 16 : 4))
                          : 4
                      ).toString(16)
                    : ""
        );

        return "__" + b;
    }

    static decodeHtml(s) {
        let el = document.createElement("textarea");
        el.innerHTML = s;
        return el.value;
    }

    static format4ReactSelect(items, keyPropName, textPropName) {
        if (!items) return [];

        if (typeof items.length === "undefined")
            return { label: items[textPropName], value: items[keyPropName] };

        if (items.length === 0) return [];

        return items.map((x) => ({
            label: x[textPropName],
            value: x[keyPropName],
        }));
    }

    static ValidateNationalCode(code) {
        if (!(/^([0-9۰-۹]{10})+$/.test(code)))
            return false
        

        let charCodeZero = "۰".charCodeAt(0);
        const toEnglish = code
            .replace(/[۰-۹]/g, (w) => w.charCodeAt(0) - charCodeZero)
            .toString();
        let res = 0;
        const splitted = toEnglish.split("");

        let index = 0;
        for (let i = 10; i != 1; i--) {
            res += +splitted[index] * i;
            index++;
        }
        const mod = res % 11;
        const lastNumber = +splitted[9]

        return ((mod < 2) && (mod === lastNumber))
        || ((mod >= 2) && ((11 - mod) === lastNumber))
    }

    static getApiPath(controller, action) {
        return `${process.env.REACT_APP_API_ROOT}/${controller}/${action}`;
    }

    static toBase64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
    }

    static toExcel(table) {
        let template =
                '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            format = (s, c) => s.replace(/{(\w+)}/g, (_, p) => c[p]);

        // remove if u want links in your table
        table = table.replace(/<a[^>]*>|<\/a>/gi, "");
        // remove if u want images in your table
        table = table.replace(/<img[^>]*>/gi, "");
        // reomves input params
        table = table.replace(/<input[^>]*>|<\/input>/gi, "");

        window.location.href = `data:application/vnd.ms-excel;base64,${helper.toBase64(
            format(template, { worksheet: "Worksheet", table })
        )}`;
    }

    static getRandomString(len, characters) {
        characters =
            characters ||
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        let result = "",
            charactersLength = characters.length;

        for (let i = 0; i < len; i++)
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );

        return result;
    }

    static getResource(key) {
        let curResource = globalResources.filter((item) => item.Key == key);

        if (curResource.length > 0) {
            switch (document.documentElement.lang) {
                case "fa-IR":
                    return curResource[0]["fa-IR"];

                case "en-US":
                    return curResource[0]["en-US"];

                default:
                    return "culture not found";
            }
        } else return "invalid key";
    }

    static getErrorMessage = (key, culture = "fa_IR") => errorMessages[key]?.values[culture]
}

export class ajaxLoader {
    static show() {
        $("#ajax-loading").addClass("active");
    }

    static hide() {
        $("#ajax-loading").removeClass("active");
    }
}

export class alert {
    static show(msg) {
        $.alert({
            title: "پیام سیستم!",
            content: msg,
            type: "red",
            animation: "top",
            closeAnimation: "bottom",
            buttons: { ok: { text: "بستن" } },
            rtl: true,
        });
    }
}

export const states = [
    { value: 3, label: "آذربایجان شرقی" },
    { value: 16, label: "آذربایجان غربی" },
    { value: 15, label: "اردبیل" },
    { value: 6, label: "اصفهان" },
    { value: 31, label: "البرز" },
    { value: 27, label: "ایلام" },
    { value: 21, label: "بوشهر" },
    { value: 1, label: "تهران" },
    { value: 24, label: "چهارمحال و بختیاری" },
    { value: 30, label: "خراسان جنوبی" },
    { value: 7, label: "خراسان رضوی" },
    { value: 29, label: "خراسان شمالی" },
    { value: 4, label: "خوزستان" },
    { value: 12, label: "زنجان" },
    { value: 9, label: "سمنان" },
    { value: 26, label: "سیستان و بلوچستان" },
    { value: 5, label: "فارس" },
    { value: 8, label: "قزوین" },
    { value: 10, label: "قم" },
    { value: 14, label: "گلستان" },
    { value: 2, label: "گیلان" },
    { value: 20, label: "لرستان" },
    { value: 13, label: "مازندران" },
    { value: 11, label: "مرکزی" },
    { value: 23, label: "هرمزگان" },
    { value: 17, label: "همدان" },
    { value: 18, label: "کردستان" },
    { value: 22, label: "کرمان" },
    { value: 19, label: "کرمانشاه" },
    { value: 28, label: "کهگلویه و بویراحمد" },
    { value: 25, label: "یزد" },
];

export const checkifyMessage = {
    inactiveForRequired: true,
    position: "right",
    email: "فرمت اطلاعات وارد شده صحیح نیست.",
    regex: "فرمت اطلاعات وارد شده صحیح نیست.",
    number: "در این فیلد تنها می توانید عدد وارد کنید.",
    maxlen: "حداکثر تعداد کاراکتر مجاز {count} است.",
    minlen: "حداقل تعداد کاراکتر مجاز {count} است.",
};
